import SeverityChart from './SeverityChart'

export default SeverityChart
